export class RegisterAccount {
  public AccountNumber?: string;
  public CustomerClass?: string;
  public IdNumber?: string;
  public PostalCode?: string;
}
